import { useEffect, useState } from 'react';
import { useT } from '../../i18n';
import {
  serverReachability,
  subscribeReachability,
  type Reachability,
} from '../../lib/api/serverReachability';

// ─────────────────────────────────────────────────────────────────────
// «SERVEREN SVARER IKKE» (#537).
//
// The screen a deploy used to produce was a blank one: the API restarts, the
// storage-first writes await a machine that is not there, the handlers bail,
// and nothing happens when you press a button. The reasonable response is to
// refresh — which is the single action that throws away the work in progress.
//
// So this says the one thing that changes what somebody does: the server is
// coming back, and refreshing is what costs you.
//
// NOT A MODAL, AND NOTHING IS BLOCKED. The app is still usable — reading,
// typing, arranging — and blocking it would take away the work somebody can
// still do while they wait. It is also not an ERROR: a restart is expected,
// it resolves by itself, and an alarm that fires on every deploy is an alarm
// people learn to ignore.
//
// IT CLEARS ITSELF. The next answered request publishes 'ok' and the banner
// goes, with no button to press and nothing to dismiss — because a dismissal
// would have to be remembered, and the state it describes can change a second
// later.
// ─────────────────────────────────────────────────────────────────────
export function ServerUnreachableBanner() {
  const t = useT();
  const [state, setState] = useState<Reachability>(serverReachability);
  useEffect(() => subscribeReachability(setState), []);

  if (state === 'ok') return null;

  return (
    <div
      data-testid="server-unreachable-banner"
      role="status"
      className="sticky top-0 z-40 flex items-center gap-3 px-4 py-2 text-sm"
      style={{ background: '#78350f', color: '#fde68a' }}
    >
      <span aria-hidden="true">●</span>
      <span className="font-semibold">{t('serverDown.title')}</span>
      {/* ON THE CATALOG, unlike the dev-only marker beside it: this is text a
          CLUB reads, at the worst possible moment, so it is not a developer
          diagnostic and does not get a developer's exemption. */}
      <span className="opacity-90">{t('serverDown.body')}</span>
    </div>
  );
}
